import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  styled,
  Stack,
  Typography,
} from '@mui/material';
import type { AccordionSummaryProps } from '@mui/material/AccordionSummary';

const ChipsAccordion = styled(Accordion)({
  display: 'flex',
  flexDirection: 'column-reverse',
  '& .MuiCollapse-root': {
    visibility: 'visible',
    minHeight: 'calc(1 * (32px + 8px)) !important',
  },
});

export const ChipsAccordionSummary = styled((props: AccordionSummaryProps) => (
  <AccordionSummary
    expandIcon={
      !props.disabled && (
        <Stack alignItems="center" direction="row" marginTop={1}>
          <Typography component="p" color="primary" variant="body2">
            Ver Mais
          </Typography>
          <ExpandMoreIcon />
        </Stack>
      )
    }
    {...props}
  />
))(({ theme }) => ({
  minHeight: '0px',
  padding: 0,
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(0deg)',

    '& .MuiSvgIcon-root': {
      transform: 'rotate(180deg)',
    },
  },
}));

export const ChipsAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  padding: 0,
}));

export { ChipsAccordion };
